<template>
  <base-editor-page :is-loading="isLoading" v-if="isReady" class="mt-0">
    <template v-slot:description>
      <p>Review data on participants who have gone through this Inbox.</p>
    </template>
    <template v-slot:body>
      <h2 class="mt-0">Overview</h2>
      <overview-container
        :versionKey="versionKey"
        :overview-data="overviewData"
        :skill-data="skillData"
        :skills="skills"
      />

      <h2 class="mt-35">Item Level</h2>
      <item-level-container
        :characters="characters"
        :questions="questions"
        :item-level-data="itemLevelData"
        :skills="skills"
      />
      <div class="row">
        <div class="col-md-6">
          <h2 class="mt-35">All Scores</h2>
        </div>
        <div class="col-md-6 text-right mt-35">
          <button @click="downloadAllScoresCSV" class="btn btn-info-dark">Generate CSV</button>
        </div>
      </div>

      <all-score-table
        @tableAttr="setAllScoresAttr($event)"
        :version-key="versionKey"
        :skills="skills"
      />
    </template>
  </base-editor-page>
</template>

<script>
  import { mapState, mapActions } from 'vuex';

  import BaseEditorPage from '@authoringPlatform/shared/BaseEditorPage.vue';
  import * as versionApi from '@authoringPlatform/../api/versions';

  import ItemLevelContainer from './ItemLevelContainer';
  import AllScoreTable from './AllScoreTable';
  import OverviewContainer from './OverviewContainer';

  export default {

    components: {
      BaseEditorPage,
      ItemLevelContainer,
      AllScoreTable,
      AllScoreTable,
      OverviewContainer,
    },

    data() {
      return {
        isLoading: false,
        itemLevelData: {},
        overviewData: {},
        skillData: {},
        allScoresTableAttr: {},
        isReady:false
      };
    },
    async created() {
      await this.getVersionData({ versionKey: this.versionKey });
      this.isReady = true;
    },


    async mounted() {
      this.isLoading = true;
      try {
        const res = await versionApi.getParticipantResults({
          versionKey: this.versionKey,
        });
        const { overviewData, skillData, itemLevelData } = res;
        this.itemLevelData = itemLevelData;
        this.overviewData = overviewData;
        this.skillData = skillData;
      } catch (e) {
        console.log(e);
      } finally {
        this.isLoading = false;
      }
    },
    methods: {
      ...mapActions('editMode', ['getVersionData']),
      setAllScoresAttr(attr) {
        this.allScoresTableAttr = attr;
      },
      downloadAllScoresCSV() {
        window.location.href = `/capsiminbox/admin/reports/send-report?versionKey=${this.versionKey}&reportType=getAllScores&sortBy=${this.allScoresTableAttr.sortBy}&direction=${this.allScoresTableAttr.direction}`;
      },
    },

    computed: {
      ...mapState('editMode/questions', ['questions']),
      ...mapState('editMode/characters', ['characters']),
      ...mapState('editMode/skills', ['skills']),
      versionKey() {
        return parseInt(this.$route.params.resourceKey);
      },
    },
  };
</script>

<style lang="scss" scoped>
  .btn-info-dark {
    background-color: #474747;
    border-color: #474747;
    color: #ffffff;
  }
</style>
